<template>
  <div>
    <navigation></navigation>
    <div class="container">
      <h3>About</h3>
      <div class="card-columns">
        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner.jpg"
            alt="Card image cap"
          />
        </div>
        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner1.jpg"
            alt="Card image cap"
          />
        </div>

        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner2.jpg"
            alt="Card image cap"
          />
        </div>

        <!-- end row 1 -->

        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner5.jpg"
            alt="Card image cap"
          />
        </div>
        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner6.jpg"
            alt="Card image cap"
          />
        </div>

        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner7.jpg"
            alt="Card image cap"
          />
        </div>

        <!-- end row 2 -->

        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner9.jpg"
            alt="Card image cap"
          />
        </div>
        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner10.jpg"
            alt="Card image cap"
          />
        </div>

        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner11.jpg"
            alt="Card image cap"
          />
        </div>

        <!-- end row 3 -->

        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner4.jpg"
            alt="Card image cap"
          />
        </div>
        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner8.jpg"
            alt="Card image cap"
          />
        </div>
        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner13.jpg"
            alt="Card image cap"
          />
        </div>

        <!-- end row 4 -->

        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner14.jpg"
            alt="Card image cap"
          />
        </div>
        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner15.jpg"
            alt="Card image cap"
          />
        </div>
        <div class="card border-0 p-2">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/about/oliver-borner16.jpg"
            alt="Card image cap"
          />
        </div>
      </div>

      <!-- end row 5 -->

      <div class="about">
        <ul>
          <li><h3>Curriculum Vitae</h3></li>
        </ul>
        <ul>
          <li><strong>1986</strong></li>
          <li>born in Dresden, Germany</li>
        </ul>
        <ul>
          <li><strong>1993-2004</strong></li>
          <li>Paintingschool Christian Neuber, Germany</li>
        </ul>
        <ul>
          <li><strong>2006-2012</strong></li>
          <li>Hochschule für bildende Künste Dresden (HfBK), Germany</li>
        </ul>
        <ul>
          <li><strong>2006-2013</strong></li>
          <li>Assistant of Holger John, Germany</li>
        </ul>
        <ul>
          <li><strong>2010-2011</strong></li>
          <li>Artist in residence, Montreal (CA) and New York (USA)</li>
        </ul>
        <ul>
          <li><strong>2012-2016</strong></li>
          <li>Artist at the Kessler Schwarz Group, Germany</li>
        </ul>
        <ul>
          <li><strong>2014-2016</strong></li>
          <li>Founder of the fashionlabel Bornutti</li>
        </ul>
        <ul>
          <li><strong>2020</strong></li>
          <li>lives and works in Dresden, Germany</li>
        </ul>
        <br />
        <ul>
          <li><h3>Exhibitions (selection)</h3></li>
        </ul>
        <ul>
          <li><strong>2017</strong></li>
          <li>
            Borner on Fire, solo exhibiton, Kunztraum Dresden
          </li>
          <li>Kunsttage, Groupshow, Sektor Dresden</li>
        </ul>

        <ul>
          <li><strong>2016</strong></li>
          <li>
            Heaven 67, Offspace Streustraße, Gallery Weekend Berlin, Berlin
          </li>
          <li>Intershop, Gallery Holger John, Dresden</li>
        </ul>

        <ul>
          <li><strong>2015</strong></li>
          <li>Home Sweet Home, Goetheallee Offspace, Dresden</li>
          <li>Frei im Raum, Friese e.V., Kirschau</li>
          <li>
            Oliver Borner / Sebastian Lukaß – Malerei, Gallery Budisyn, Bautzen
          </li>
          <li>Step Back Show, Altkötzschenbroda, Radebeul</li>
        </ul>

        <ul>
          <li><strong>2014</strong></li>
          <li>Borner Lukaß, Gallery Holger John, Dresden</li>
          <li>Künstler im Selbstbildnis, Ostsächsische Kunsthalle, Pulsnitz</li>
          <li>Total Sellout, Store</li>
          <li>Salon Hansa, Galerie Holger John</li>
        </ul>

        <ul>
          <li><strong>2013</strong></li>
          <li>eins*, Dresdner Porzellan</li>
          <li>
            Festmahl der Kunst – Holger John, Palais im Großen Garten Dresden
          </li>
          <li>Verbotene Kunst 2, Goldener Pfeil, Dresden</li>
        </ul>

        <ul>
          <li><strong>2012</strong></li>
          <li>Mon General, Art Bosphorus, Istanbul (Turkey)</li>
          <li>Apokalypse, Galerie F14, Dresden</li>
          <li>FSK 18, Drewaggelände Dresden</li>
          <li>Defluxion, Dresden</li>
        </ul>

        <ul>
          <li><strong>2011</strong></li>
          <li>Art residency in Montreal, Quebec Canada</li>
        </ul>

        <ul>
          <li><strong>2010</strong></li>
          <li>In the Womb, Galerie Forum K, Plauen (Borner & Wagner)</li>
          <li>Salon Zaza, Dresden</li>
        </ul>

        <ul>
          <li><strong>2009</strong></li>
          <li>Frühjahrssalon, Galerie Zanderkasten, Dresden</li>
        </ul>

        <ul>
          <li><strong>2008</strong></li>
          <li>Ultimatum, Galerie Alte Feuerwache, Dresden</li>
        </ul>
      </div>
    </div>
    <back-to-top bottom="20px" right="20px">
      <button type="button" class="btn btn-light btn-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";
export default {
  components: {
    navigation,
  },
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
</style>
